/**
 * @flow
 * @relayHash 84ffbe68ee0078436f7419aa6668c22b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ExperimentActionReferralNotification = "CLICK" | "DISMISS" | "NONE" | "%future added value";
export type ExperimentActionSearchIntro = "CLICK" | "DISMISS" | "NONE" | "%future added value";
export type LogUserExperimentActionsInput = {|
  userId: string,
  experimentActions?: ?ExperimentActions,
  clientMutationId?: ?string,
|};
export type ExperimentActions = {|
  searchIntro?: ?ExperimentActionSearchIntro,
  referralNotification?: ?ExperimentActionReferralNotification,
|};
export type LogUserExperimentActionsMutationVariables = {|
  input: LogUserExperimentActionsInput
|};
export type LogUserExperimentActionsMutationResponse = {|
  +logUserExperimentActions: ?{|
    +user: ?{|
      +id: string
    |}
  |}
|};
export type LogUserExperimentActionsMutation = {|
  variables: LogUserExperimentActionsMutationVariables,
  response: LogUserExperimentActionsMutationResponse,
|};
*/


/*
mutation LogUserExperimentActionsMutation(
  $input: LogUserExperimentActionsInput!
) {
  logUserExperimentActions(input: $input) {
    user {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogUserExperimentActionsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logUserExperimentActions",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogUserExperimentActionsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LogUserExperimentActionsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LogUserExperimentActionsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "LogUserExperimentActionsMutation",
    "id": null,
    "text": "mutation LogUserExperimentActionsMutation(\n  $input: LogUserExperimentActionsInput!\n) {\n  logUserExperimentActions(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '332a5dcb4a90c588d99f249760334104';
module.exports = node;
